import { render, staticRenderFns } from "./LeaderboardTeam.vue?vue&type=template&id=529328a9&scoped=true&"
import script from "./LeaderboardTeam.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTeam.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTeam.vue?vue&type=style&index=0&id=529328a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529328a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
